import React from 'react';
import { Select, TreeSelect, TreeSelectProps, SelectProps } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import {
  FilterCommonInnerProps,
  FilterCommonProps,
} from '@/component/FilterCommon/Filter';
import { axiosHttp } from '@/utils/http';
import {
  serviceStaffs,
} from '@/component/Filter/services/common/filter';
import { isError } from '@/component/common/error';
import { useSearchConditionPc } from '../hooks/useSearchCondition';
import { SelectModalPc } from '../Common/SelectModalPc';
import { FilterPc } from '../FilterPc';
import { FilterSelectPc } from '../FilterSelect/FilterSelectPc';

export interface FilterStaffBranchPcProps extends SelectProps {}

export const FilterStaffBranchPc = (props: FilterStaffBranchPcProps,) => {
  const { searchCondition, loading, getInitData } = useSearchConditionPc({ staff: ['branch'] });
  let branchs = searchCondition.staff?.branch || [];
  const { ...reset } = props;
  const options = branchs
  return (
    <div>
      <FilterSelectPc
        style={{ width: '100%' }}
        allowClear
        loading={loading}
        getInitData={getInitData}
        {...reset}
        onChange={(value, option) => {
          props.onChange && props.onChange(value, option);
        }}
        options={options}
      />
    </div>
  );
};
